export type OrganizationOption = {
  code: string;
  name: string;
};

export const organizationOptions: OrganizationOption[] = [
  { code: 'KMCM', name: '감리교선교국' },
  { code: 'The Frontiers', name: '개척자들' },
  { code: '기독교대한성결교단', name: '기독교대한성결교단' },
  { code: '두란노국제선교회CITM', name: '두란노국제선교회(ITM)' },
  { code: '모퉁이돌선교회', name: '모퉁이돌선교회' },
  { code: '바울선교회', name: '바울선교회' },
  { code: '불어건선교회', name: '불어건선교회' },
  { code: '빌리온선교회', name: '빌리온선교회' },
  { code: '세계스포츠선교회', name: '세계스포츠선교회' },
  { code: '알타이선교회', name: '알타이선교회' },
  { code: '어린이전도협회해외/선교', name: '어린이전도협회해외선교사역부' },
  { code: 'YWAM', name: '예수전도단' },
  { code: '오병이어선교회', name: '오병이어선교회' },
  { code: 'ONEBODY', name: '원바디(OneBody)' },
  { code: '인터서브', name: '인터서브' },
  { code: '중국대학생선교회', name: '중국대학생선교회' },
  { code: '중국복음선교회', name: '중국복음선교회' },
  { code: '중국어문선교회', name: '중국어문선교회' },
  { code: '중동선교회', name: '중동선교회' },
  { code: 'PCKWM', name: '총회세계선교부(PCKWM)' },
  { code: 'GMS', name: '총회세계선교회(GMS)' },
  { code: 'GMS', name: '침례교해외선교회' },
  { code: 'KONA', name: '코나뱅타' },
  { code: '프론티어스국제선교회', name: '프론티어스국제선교회' },
  { code: '한국회향', name: '한국회향' },
  { code: '합신세계선교회', name: '합신세계선교회' },
  { code: 'HJY', name: '한국지역아동센터연합회(HJY)' },
  { code: 'PMS', name: '합신세계선교회(PMS)' },
  { code: 'ANF', name: 'AIM선교회' },
  { code: 'ANF', name: 'ANE선교회' },
  { code: 'ANN', name: 'ANN' },
  { code: 'BTC', name: 'BTC' },
  { code: 'ENM', name: 'ENM(세계로선교회)' },
  { code: 'FMnC', name: 'Fim' },
  { code: 'FMnC', name: 'FMnC' },
  { code: 'GBT', name: 'GBT' },
  { code: 'GFC', name: 'GFC' },
  { code: 'GMP', name: 'GMP' },
  { code: 'Global Operation', name: 'GO선교회' },
  { code: 'GP', name: 'GP선교회' },
  { code: 'HOPE', name: 'HOPE' },
  { code: 'MVP', name: 'MVP선교회' },
  { code: 'NIBCM', name: 'NIBCM(은누리제자선교회)' },
  { code: 'NTM', name: 'NTM' },
  { code: 'OM', name: 'OM' },
  { code: 'OMF', name: 'OMF' },
  { code: 'SEED', name: 'SEED 선교회' },
  { code: 'SFC', name: 'SFC' },
  { code: 'SIM', name: 'SIM(한국에스아이엠국제선교회)' },
  { code: 'WEC', name: 'WEC' },
  { code: 'WEM', name: 'WEM' },
  { code: 'ETC', name: '기타' },
];

const normalize = (value?: string) => String(value ?? '').trim().toLowerCase();

const codeToDisplay = new Map<string, string>();
const codeToCanonical = new Map<string, string>();
const nameToCode = new Map<string, string>();

organizationOptions.forEach((option) => {
  const codeKey = normalize(option.code);
  const nameKey = normalize(option.name);
  if (!codeToDisplay.has(codeKey)) codeToDisplay.set(codeKey, option.name);
  if (!codeToCanonical.has(codeKey)) codeToCanonical.set(codeKey, option.code);
  if (!nameToCode.has(nameKey)) nameToCode.set(nameKey, option.code);
});

export const getOrganizationDisplayName = (value?: string) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  return codeToDisplay.get(normalize(raw)) || raw;
};

export const getOrganizationCode = (value?: string) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const normalized = normalize(raw);
  if (codeToCanonical.has(normalized)) return codeToCanonical.get(normalized) || raw;
  return nameToCode.get(normalized) || raw;
};
